export const faCenterVertically = {
  prefix: 'fpm',
  iconName: 'fa-center-vertically',
  icon: [
    24,
    24,
    [],
    'e001',
    'M6.76 8.04v3.04H3v.96h3.76v6.04h3.92v-6.04h3.28v3.76h3.92v-3.76h3.76v-.959l-1.87-.011-1.87-.01-.01-1.89-.011-1.89H13.96v3.801l-1.63-.011-1.63-.01-.01-3.03L10.679 5H6.76v3.04',
  ],
};
